export const ASYNC_ACTION_START = 'common/ASYNC_ACTION_START';
export const ASYNC_ACTION_WITH_SPINNER_START =
  'common/ASYNC_ACTION_WITH_SPINNER_START';
export const ASYNC_ACTION_END = 'common/ASYNC_ACTION_END';

export const LOADING = 'common/LOADING';
export const ADD_PATHNAME = 'common/ADD_PATHNAME';
